<template>
  <div class="case-detail-gene-pedigree-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailGenePedigree.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block" v-for="(variant, vindex) in variantDatas" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ width: '5px' }"></div>
        <img :src="require('../../assets/images/external-link-icon.svg')" alt="" :style="{ cursor: 'pointer' }" @click="e => openGenomeBrowser(variant)">
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block">
        <caseFamilyPedigree
          :caseData="caseData"
          :variant="variant"
          :sampleAllelegts="sampleAllelegts"
        ></caseFamilyPedigree>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import caseFamilyPedigree from '../case/familyPedigree.vue'

export default {
  components: {
    caseFamilyPedigree
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    variantDatas () {
      return Object.values(this.variants).map(variant => ({
        ...variant,
        type: variant.fam_info ? 'trio' : 'single',
        fam_info: variant.fam_info || [{
          ...this.caseData,
          GT: variant.GT_raw,
          RefAlt: [variant.REF, variant.ALT].join(' > '),
          relation: 'Proband'
        }]
      }))
    },
    // param
    caseData () {
      return this.param.caseData
    },
    project () {
      return this.param.project
    },
    type () {
      return this.param.type
    },
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    sampleAllelegts () {
      return this.param.sampleAllelegts
    }
  },
  methods: {
    openGenomeBrowser (variant) {
      window.open(window.location.origin + '/genomeBrowser/' + [this.$route.params.id, this.project.id].join('-') + '/' + this.type + '/' + this.gene.SYMBOL + '/' + variant.CHROM + '%3A' + variant.POS + '%3A' + variant.REF + '%3A' + variant.ALT)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGenePedigree.vue